import React from "react";
import Label from "./Label";
import { motion } from "framer-motion";
import { Reveal } from "../Common/Reveal";

const Details = () => {
  return (
    <div className="flex flex-col text-left pt-5">
      <motion.h2
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="font-medium text-lg text-amber-500 dark:text-amber-200 mt-5 mb-1"
      >
        <Reveal width="100%">Programming Languages</Reveal>
      </motion.h2>
      <motion.div
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="flex gap-2"
      >
        <Label indicator={90}>Javascript</Label>
        <Label indicator={70}>Typescript</Label>
        <Label indicator={90}>Python</Label>  
        <Label indicator={70}>Java</Label>  
        <Label indicator={70}>C++</Label>
        <Label indicator={70}>C#</Label>
        <Label indicator={70}>SQL</Label>

      </motion.div>

      <motion.h2
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="font-medium text-lg text-amber-500 dark:text-amber-200 mt-5 mb-1"
      >
        <Reveal width="100%">Technologies</Reveal>
      </motion.h2>
      <motion.div
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="flex flex-wrap gap-2"
      >
        <Label indicator={95}>React.js</Label>
        <Label indicator={95}>Next.js</Label>
        <Label indicator={80}>Redux</Label>
        <Label indicator={80}>Node.js</Label>
        <Label indicator={80}>Express.js</Label>
        <Label indicator={80}>MongoDB</Label>
        <Label indicator={80}>MySQL</Label>
        <Label indicator={80}>Tailwind CSS</Label>
        <Label indicator={80}>.NET</Label>
        <Label indicator={80}>Angular</Label>
        <Label indicator={80}>Bootstrap</Label>



 
      </motion.div>

      <motion.h2
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="font-medium text-lg text-amber-500 dark:text-amber-200 mt-5 mb-1"
      >
        <Reveal width="100%">Softwares and Tools</Reveal>
      </motion.h2>
      <motion.div
        initial={{ x: -50, opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="flex flex-wrap gap-2"
      >
        <Label indicator={80}>Git</Label>
        <Label indicator={90}>GitHub</Label>
        <Label indicator={100}>VS Code</Label>
        <Label indicator={70}>Postman</Label>
        <Label indicator={70}>Docker</Label>
        <Label indicator={70}>Figma</Label>
        <Label indicator={70}>Jira</Label>
        <Label indicator={70}>Slack</Label>
        <Label indicator={70}>Trello</Label>
        <Label indicator={70}>AWS</Label>
        <Label indicator={70}>Azure</Label>
        <Label indicator={70}>Google Cloud</Label>
        <Label indicator={70}>Firebase</Label>
        
      </motion.div>
    </div>
  );
};

export default Details;
